<mat-tab-group>
  <mat-tab label="Gabinetes"> <app-organizations></app-organizations> </mat-tab>
  <mat-tab label="Usuários"> <app-admin-users></app-admin-users> </mat-tab>
  <mat-tab label="Eventos Recorrentes"> <app-recurring-events></app-recurring-events> </mat-tab>
</mat-tab-group>
